import { SET_PRESCRIPTIONS} from "constants/ActionTypes";
import {FETCH_START_PRESCRIPTIONS, FETCH_SUCCESS_PRESCRIPTIONS, SET_ACTION_PRESCRIPTIONS, FETCH_ERROR_PRESCRIPTIONS} from "../../constants/ActionTypes";

const INIT_STATE = {
	error: "",
	loading: false,
	message: "",
	response: null,
	action: "",
	prescriptions: null
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
	case FETCH_START_PRESCRIPTIONS: {
		return {...state, error: "", message: "", loading: true, response: null};
	}
	case FETCH_SUCCESS_PRESCRIPTIONS: {
		return {...state, error: "", message: "", loading: false, response: null};
	}
	case SET_ACTION_PRESCRIPTIONS: {
		return {...state, action: action.payload};
	}
	case FETCH_ERROR_PRESCRIPTIONS: {
		return {...state, loading: false, error: action.payload, message: "", response: false};
	}
	case SET_PRESCRIPTIONS: {
		return {...state, prescriptions: action.payload};
	}
	default:
		return state;
	}
};
